import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {proto,url} from '../Helpers/api';
import {get,mapValues,orderBy,groupBy} from 'lodash-es';
import Tabela, {TabelaLinha as TL} from '../Common/Tabela';
import CelulaHeader from '../Common/CelulaHeader';
import Celula from '../Common/Celula';
import styled from 'styled-components';
import {m_fetch} from '../Helpers/auth';
// import {fetch as authFetch, m_fetch} from '../Helpers/auth';

const TabelaLinha = styled(TL)`
  grid-template-columns: 40px 270px 162px 82px 82px 82px 82px 42px;
`
const Foto = styled.div`
  position: relative;
  & > div {
    display: none;
    background: white;
    border: 1px solid gray;
    position: absolute;
    float: left;
    top: 0;
    left: 0;
    z-index: 2000;
  }
  & > div > img {
    height: auto;
    width: 70px;
  }
  &:hover {
    & > div {
      display: block;
    }
  }
`

let listaEstadoCivil = {
  "S":"Solteiro",
  "C":"Casado",
  "V":"Viúvo",
  "D":"Divorciado",
  "O":"Concubinato",
  "J":"Separado judicialmente",
  "U":"União estável",
}

const lerEstadoCivil = c => listaEstadoCivil[c]
const lerVinculo = c => c ? "Não" : "Sim"
const lerFoto = c => c ? (
  <Foto>
    Possui
    <div>
      <img src={c} alt=""/>
    </div>
  </Foto>
) : "-"

const lerDepto = (c,props) => {
  const { dptosById } = props;
  return get(dptosById,c,{nome:""}).nome;
}

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const initial = {
  empregadosById: {},
  dptosById: {},
  raw: {},
  sort: { sortBy: null, desc: false },
  ids: []
}
class Empregados extends Component {
  state = initial
  setSort = (idx) => () => {
    this.setState(({sort,raw}) => {
      let desc = (sort.sortBy === idx) ? !sort.desc : false
      let order = desc ? "desc" : "asc"
      let list = orderBy(raw.list, [idx], [order])
      let ids = Object.values(mapValues(list,"Codigo"))
      return { sort: { sortBy: idx, desc }, ids }
    })
  }  
  fetch_ = (empresa) => (
    // TODO -> trocar para MultipleFetch
    // Promise.all([
    //   authFetch(`${proto}://${url}/main/empregados/${empresa}/lista`),
    //   authFetch(`${proto}://${url}/main/empregados/${empresa}/rescisoes`),
    //   authFetch(`${proto}://${url}/main/dpto/${empresa}`)
    // ])
    m_fetch([
      `${proto}://${url}/main/empregados/${empresa}/lista`,
      `${proto}://${url}/main/empregados/${empresa}/rescisoes`,
      `${proto}://${url}/main/dpto/${empresa}`
    ])
      .then(r=>Promise.all(r.map(_=>_.json())))
      .then(r => this.setState(state => {
        let list = r[0]
        let resc = r[1]
        let dptos = r[2]
        let _1 = mapValues(groupBy(list, "Codigo"), d=>d[0])
        let _2 = mapValues(groupBy(resc, "i_empregados"), d=>d[0])
        let empregadosById = {}
        let dptosById = mapValues(groupBy(dptos, "i_depto"), d=>d[0])
        Object.keys(_1).forEach(k => {
          empregadosById[k] = _1[k]
          empregadosById[k].Rescisao = _2[k]
        })
        let ids = Object.values(mapValues(list,"Codigo"))
        return {
          raw: { list, resc, dptos },
          empregadosById,
          dptosById,
          ids
        }
      }))
  )

  componentDidUpdate(pProps) {
    const { empresa, dialog } = this.props;
    const { id } = empresa;
    if (!pProps.dialog && dialog) {
      this.fetch_(id)
    } else if (pProps.dialog && !dialog) {
      this.setState(initial)
    }
  }

  render() {
    return (
      <EmpregadosUI 
        {...this.props}
        {...this.state}
        sort={{
          set: this.setSort,
          ...this.state.sort
        }}
      />
    )
  }
}

const EmpregadosUI = props => {
  const { dialog, setDialog, empresa, empregadosById, dptosById, ids } = props;
  return (
    <Dialog
      fullScreen
      open={dialog}
      onClose={()=>setDialog(false)}
      TransitionComponent={Transition}
    >
      <AppBar>
        <Toolbar>
          <Typography variant="title" color="inherit">
            Empregados {empresa.id}
          </Typography>
          <IconButton color="inherit" onClick={()=>setDialog(false)} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <EmpregadosList {...props} />
    </Dialog>
  )
}

const EmpregadosList = props => {
  const { empregadosById, sort, ids } = props;
  const fields = [
    ["Codigo", "Cod"],
    ["Nome", "Nome"],
    ["Departamento", "Departamento", lerDepto],
    ["EstadoCivil", "Estado Civil", lerEstadoCivil],
    ["Rescisao", "Possui Vínculo", lerVinculo],
    ["Admissao", "Admissão em"],
    ["Rescisao.COMPETENCIA", "Rescisão em"],
    ["Foto", "Foto", lerFoto],
  ]
  return (
    <div style={{marginTop:"70px"}}>
      <Tabela>
        <TabelaLinha header>
        {fields.map((f,i) => (
          <CelulaHeader key={"a"+i} field={f} sort={sort}/>
        ))}
        </TabelaLinha>
        {ids.map((id,i0) => (
          <TabelaLinha>
            {fields.map((f,i1) => {
              let d = get(empregadosById[id],f[0])
              let val = f[2] ? f[2](d,props) : d
              return (
                <Celula key={"c"+i0+i1}>{val}</Celula>
              )
            })}
          </TabelaLinha>
        ))}
      </Tabela>
    </div>
  )
}

export default Empregados
